(function () {
  function fmt(n) { return n.toLocaleString('de-DE', { maximumFractionDigits: 2 }); }
  function num(v) { return parseFloat((v || '').toString().replace(',', '.')); }
  function areaOf(shape, size) {
    if (shape.type === 'circle') { var r = size[0] / 200; return Math.PI * r * r; }
    return (size[0] / 100) * (size[1] / 100);
  }
  function sizeLabel(shape, size) {
    return shape.type === 'circle' ? ('ø ' + size[0] + ' cm') : (size[0] + '×' + size[1] + ' cm');
  }
  // Größen ab shape.xxlIdx gehören zum XXL-Produkt → korrekten Produktlink wählen.
  function ctaFor(shape, idx) {
    if (shape.xxlIdx != null && idx >= shape.xxlIdx && shape.urlXXL) {
      return { url: shape.urlXXL, xxl: true };
    }
    return { url: shape.url, xxl: false };
  }
  function recommendSet(sets, req) {
    for (var i = 0; i < sets.length; i++) { if (req <= sets[i].qm) return { set: sets[i], count: 1 }; }
    var last = sets[sets.length - 1];
    return { set: last, count: Math.ceil(req / last.qm) };
  }
  function esc(s) { return (s == null ? '' : String(s)).replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function init(root) {
    if (!root || root.getAttribute('data-wb-calc-ready') === '1') return;
    var dataEl = root.querySelector('[data-wb-calc-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.setAttribute('data-wb-calc-ready', '1');

    var factor = parseFloat(data.factor);
    if (!(factor > 0)) factor = 0.07;
    var factorTxt = factor.toLocaleString('de-DE', { maximumFractionDigits: 4 });
    var sets = data.sets || [];
    var shapes = data.shapes || [];
    var req = 0;

    var elL = root.querySelector('[data-wb-l]');
    var elB = root.querySelector('[data-wb-b]');
    var elH = root.querySelector('[data-wb-h]');
    var elErr = root.querySelector('[data-wb-error]');
    var out = root.querySelector('[data-wb-out]');
    var elVol = root.querySelector('[data-wb-vol]');
    var elArea = root.querySelector('[data-wb-area]');
    var elFloor = root.querySelector('[data-wb-floor]');
    var elFormula = root.querySelector('[data-wb-formula]');
    var elSet = root.querySelector('[data-wb-set]');
    var elShapes = root.querySelector('[data-wb-shapes]');

    function renderSet() {
      var r = recommendSet(sets, req), s = r.set, c = r.count, covered = s.qm * c;
      var countTxt = c > 1 ? (c + ' × ' + s.name) : s.name;
      elSet.innerHTML =
        '<div class="wb-calc__rec">' +
          (s.img ? '<img src="' + esc(s.img) + '" alt="' + esc(s.name) + '" loading="lazy" width="130" height="130">' : '') +
          '<div class="wb-calc__rec-info">' +
            '<span class="wb-calc__tag">Einfachste Lösung</span>' +
            '<h3>' + esc(countTxt) + '</h3>' +
            '<p>' + esc(s.room) + ' · deckt rund ' + fmt(covered) + ' m² Absorberfläche ab und passt damit zu deinem Ergebnis von ' + fmt(req) + ' m².</p>' +
            '<a class="wb-calc__cta" href="' + esc(s.url) + '">Set ansehen →</a>' +
          '</div>' +
        '</div>';
    }

    function cardHTML(shape, idx) {
      var opts = '';
      for (var i = 0; i < shape.sizes.length; i++) {
        var a = areaOf(shape, shape.sizes[i]);
        opts += '<option value="' + i + '"' + (i === shape.def ? ' selected' : '') + '>' + sizeLabel(shape, shape.sizes[i]) + ' (' + fmt(a) + ' m²)</option>';
      }
      return '<div class="wb-calc__card">' +
        (shape.img ? '<img src="' + esc(shape.img) + '" alt="' + esc(shape.name) + '" loading="lazy">' : '') +
        '<div class="wb-calc__card-b">' +
          '<h3>' + esc(shape.name) + '</h3>' +
          '<select data-idx="' + idx + '" aria-label="Größe für ' + esc(shape.name) + '">' + opts + '</select>' +
          '<p class="wb-calc__qty" data-wb-q="' + idx + '"></p>' +
          '<p class="wb-calc__cover" data-wb-c="' + idx + '"></p>' +
          '<a class="wb-calc__cta" data-wb-cta="' + idx + '" href="' + esc(ctaFor(shape, shape.def).url) + '">' + (ctaFor(shape, shape.def).xxl ? 'Zum XXL-Produkt →' : 'Zum Produkt →') + '</a>' +
        '</div>' +
      '</div>';
    }

    function updateCard(idx) {
      var shape = shapes[idx];
      var sel = elShapes.querySelector('select[data-idx="' + idx + '"]');
      if (!sel) return;
      var size = shape.sizes[parseInt(sel.value, 10)];
      var a = areaOf(shape, size);
      var qty = Math.max(1, Math.ceil(req / a));
      var covered = qty * a;
      elShapes.querySelector('[data-wb-q="' + idx + '"]').innerHTML = '<b>' + qty + '</b> <span>Stück benötigt</span>';
      elShapes.querySelector('[data-wb-c="' + idx + '"]').textContent = 'deckt ' + fmt(covered) + ' m² ab';
      var ct = ctaFor(shape, parseInt(sel.value, 10));
      var cta = elShapes.querySelector('[data-wb-cta="' + idx + '"]');
      if (cta) { cta.href = ct.url; cta.textContent = ct.xxl ? 'Zum XXL-Produkt →' : 'Zum Produkt →'; }
    }

    function renderShapes() {
      var html = '';
      for (var i = 0; i < shapes.length; i++) { html += cardHTML(shapes[i], i); }
      elShapes.innerHTML = html;
      for (var j = 0; j < shapes.length; j++) { updateCard(j); }
      elShapes.querySelectorAll('select').forEach(function (sel) {
        sel.addEventListener('change', function () { updateCard(parseInt(this.getAttribute('data-idx'), 10)); });
      });
    }

    function showError(msg) { if (elErr) { elErr.textContent = msg; elErr.hidden = false; } }
    function clearError() { if (elErr) { elErr.hidden = true; elErr.textContent = ''; } }

    function calc() {
      var lc = num(elL.value), bc = num(elB.value), hc = num(elH.value); // Eingaben in cm
      if (!(lc > 0) || !(bc > 0) || !(hc > 0)) {
        showError('Bitte gib gültige Werte (größer als 0) für Länge, Breite und Höhe ein.');
        return;
      }
      clearError();
      var l = lc / 100, b = bc / 100, h = hc / 100; // cm -> m
      var vol = l * b * h;
      req = vol * factor;
      elVol.textContent = fmt(vol);
      elArea.textContent = fmt(req);
      elFloor.textContent = fmt(l * b);
      elFormula.innerHTML =
        '<strong>So gerechnet:</strong> ' + fmt(lc) + ' cm × ' + fmt(bc) + ' cm × ' + fmt(hc) + ' cm = ' + fmt(vol) +
        ' m³ Raumvolumen · × ' + factorTxt + ' = <strong>' + fmt(req) + ' m² Absorberfläche</strong>.';
      renderSet();
      renderShapes();
      out.hidden = false;
      out.classList.add('is-visible');
      out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    var goBtn = root.querySelector('[data-wb-go]');
    if (goBtn) goBtn.addEventListener('click', calc);
    [elL, elB, elH].forEach(function (el) {
      if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { calc(); } });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wb-calc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
